import { render, staticRenderFns } from "./afterDetail.vue?vue&type=template&id=0974fd7c&"
import script from "./afterDetail.vue?vue&type=script&lang=js&"
export * from "./afterDetail.vue?vue&type=script&lang=js&"
import style0 from "./afterDetail.vue?vue&type=style&index=0&id=0974fd7c&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0974fd7c')) {
      api.createRecord('0974fd7c', component.options)
    } else {
      api.reload('0974fd7c', component.options)
    }
    module.hot.accept("./afterDetail.vue?vue&type=template&id=0974fd7c&", function () {
      api.rerender('0974fd7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/afterDetail.vue"
export default component.exports